export const DOCUMENTATION_ROUTES = {
  index: '/workspace/:workspaceSlug/documentation',
  create: '/workspace/:workspaceSlug/documentation/new',
  edit: '/workspace/:workspaceSlug/documentation/:itemId/edit',
  portal: '/portal/:slug/knowledge/documentation'
};
